import React, { useEffect } from 'react';

import { Box, Grid, Paper } from '@mui/material';

import { ECameraType } from '~/domain/ECameraType';
import { ICamera } from '~/domain/ICamera';
import { IImageSettings } from '~/domain/IImageSettings';
import * as LAYOUT from '~/pages/layout';
// import { useRequestUrl } from '~/hooks/useRequestUrl';

import { VehicleImage } from './VehicleImage';

interface IFeatureShotList {
  settings: IImageSettings;
  cameras: ICamera[];
  camera?: ICamera;
}

//const CAMERA_TYPES = [ECameraType.FEATURE_EXT, ECameraType.FEATURE_INT];

export const FeatureShotList: React.FC<IFeatureShotList> = (props) => {
  const { camera, cameras, settings } = props;

  let CAM_TYPES: string[] = [];

  if (
    !camera &&
    window.location.href.toLowerCase().indexOf('retailer') === -1
  ) {
    CAM_TYPES = [ECameraType.FEATURE_EXT, ECameraType.FEATURE_INT];
  } else {
    CAM_TYPES = [ECameraType.FEATURE_RETAILER];
  }

  const featureShotCameras = cameras.filter((camera) =>
    CAM_TYPES.includes(camera.type)
  );

  useEffect(() => {
    //console.log('back in FeatureShotList');
    checkScroll();
  }, []);

  const checkScroll = () => {
    try {
      const urlObject = new URL(window.location.href);
      const params = new URLSearchParams(urlObject.search);
      const id = params.get('id');

      if (id) {
        //console.log('id:', id);
        const elem = document.getElementById(id);
        if (elem) {
          elem.scrollIntoView();
        }
      }
    } catch (error) {
      // Handle cases where the URL is invalid
      console.error('Invalid URL:', error);
      return false;
    }
  };

  return (
    <Box sx={{ height: '100%', overflow: 'auto' }}>
      <Paper component="main" id="main" sx={[LAYOUT.BODY, { padding: '20px' }]}>
        <Grid container spacing={2}>
          {featureShotCameras.map((camera) => {
            return (
              <Grid key={camera.code} item xs={6} sm={6} md={4} lg={4} xl={4}>
                <VehicleImage camera={camera} settings={settings} />
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    </Box>
  );
};
